import {
  LEGALSTATUS_LOADING,
  GET_LEGALSTATUS,
  GET_LEGALSTATUS_SUCCESS,
  GET_LEGALSTATUS_FAIL,
  ADD_LEGALSTATUS_SUCCESS,
  ADD_LEGALSTATUS_FAIL,
  DELETE_LEGALSTATUS_SUCCESS,
  DELETE_LEGALSTATUS_FAIL,
  UPDATE_LEGALSTATUS_SUCCESS,
  UPDATE_LEGALSTATUS_FAIL,
  LEGALSTATUS_RESET,
} from "./actionType";

const INIT_STATE = {
  legalStatus: [],
  error: {},
};

const LegalStatus = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEGALSTATUS_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LEGALSTATUS:
          return {
            ...state,
            legalStatus: action.payload.data,
            isLegalStatusCreated: false,
            isLegalStatusSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LEGALSTATUS_FAIL:
      switch (action.payload.actionType) {
        case GET_LEGALSTATUS_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLegalStatusCreated: false,
            isLegalStatusSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LEGALSTATUS: {
      return {
        ...state,
        isLegalStatusCreated: false,
        loading: true,
      };
    }

    case LEGALSTATUS_LOADING: {
      return {
        ...state,
        isLegalStatusCreated: false,
        loading: true,
      };
    }

    case ADD_LEGALSTATUS_SUCCESS:
      return {
        ...state,
        isLegalStatusCreated: true,
        loading: false,
        legalStatus: [action.payload.data, ...state.legalStatus],
      };

    case ADD_LEGALSTATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LEGALSTATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        isLegalStatusCreated: true,
        legalStatus: state.legalStatus.filter(
          (legalStatus) =>
            legalStatus.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LEGALSTATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LEGALSTATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        isLegalStatusCreated: true,
        legalStatus: state.legalStatus.map((legalStatus) =>
          legalStatus.id.toString() === action.payload.data.id.toString()
            ? { ...legalStatus, ...action.payload.data }
            : legalStatus
        ),
      };

    case UPDATE_LEGALSTATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LEGALSTATUS_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default LegalStatus;
